import { SecondaryButton } from "common";
import React from "react";
import { useHistory } from "react-router-dom";
import { Membership } from "types";
import { ProductPhotoList } from "../../ProductPhotoList";
import { ContentLayout } from "@/components/Layout/ContentLayout";

export const MembershipPhotoList = ({ membership }: { membership: Membership }) => {
    const history = useHistory();

    const handleCancel = () => {
        history.push(`/products/memberships`);
    };

    return (
        <ContentLayout isWide>
            <ContentLayout.Section
                title="Photos"
                description="You can add a maximum of 10 .jpg, .png and .webp images to each product with a maximum size of 5 MB. Suggested pixel dimensions 1024x768"
            >
                <ProductPhotoList product={membership} />
            </ContentLayout.Section>

            <ContentLayout.Footer preferenceSidebar>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
